import { PeriodType } from "../../../../types";
import { Entity, IEntity } from "../../../entity"

export interface IReportPeriodType extends IEntity {
  name: string;
  value: number;
  nameKey?: string;
}

export class ReportPeriodType extends Entity implements IReportPeriodType {
  name: string;
  value: number;

  get nameKey(): string {
    return `pages.xunta.reportPeriod.types.${this.name}`;
  }

  constructor(data: IReportPeriodType) {
    super(data);
    this.name = data.name;
    this.value = data.value;
  }
}

export class ReportPeriodsData {
  static periods: ReportPeriodType[] = [
    new ReportPeriodType({ id: 'monthly', name: 'monthly', value: 1, createdAt: new Date(), updatedAt: new Date() }),
    new ReportPeriodType({ id: 'quarterly', name: 'quarterly', value: 3, createdAt: new Date(), updatedAt: new Date() }),
    new ReportPeriodType({ id: 'semiannual', name: 'semiannual', value: 6, createdAt: new Date(), updatedAt: new Date() }),
    new ReportPeriodType({ id: 'annual', name: 'annual', value: 12, createdAt: new Date(), updatedAt: new Date() }),
    new ReportPeriodType({ id: 'fullPeriod', name: 'fullPeriod', value: 0, createdAt: new Date(), updatedAt: new Date() }),
    new ReportPeriodType({ id: 'customized', name: 'customized', value: 0, createdAt: new Date(), updatedAt: new Date() }),
  ];

  static getPeriodByName(name: PeriodType): ReportPeriodType | undefined {
    return this.periods.find(period => period.name === name);
  }

  static getAllPeriods(): ReportPeriodType[] {
    return this.periods;
  }

  static getValidPeriods(): ReportPeriodType[] {
    return this.periods
      .filter(period => period.name !== 'customized' && period.name !== 'fullPeriod');
  }
}
